import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseButtonComponent } from '../base/base-button.component';
import { ButtonGroupOptions } from '../../models/button-group.models';
import { ButtonType, PrimeButtonStyle, PrimeNGButtonStyle, PrimeVariant } from '../base/button.properties';
import { IconType } from '@shared/utils/icons';

@Component({
  selector: 'shared-ui-buttons-button-group',
  templateUrl: './button-group.component.html',
  styleUrls: ['./button-group.component.css'],
  standalone: false,
})
export class ButtonGroupComponent extends BaseButtonComponent implements OnInit {
  @Input() options: ButtonGroupOptions[] = new Array<ButtonGroupOptions>();
  @Input() dropdownIcon: IconType = IconType.Cog;
  @Output() action = new EventEmitter<void>();
  buttonType = ButtonType;
  primeVariant = PrimeVariant;

  constructor() {
    super();
  }

  ngOnInit(): void {}

  get primeButtonStyle(): PrimeNGButtonStyle {
    return PrimeButtonStyle[this.type];
  }

  handleAction(): void {
    this.action.emit();
  }
}
